import { BaseFormat } from "./baseFormat";

// Foto final 5,1cm × 7,1cm (retrato): 5×7 com 0,5mm a mais em cada lado. Na
// folha 15×10cm as 4 cópias ficam deitadas (7,1×5,1cm) em grade 2×2 — ver
// composePassaporteSheet em useExport.
export const PASSAPORTE_LARGURA_CM = 5.1;
export const PASSAPORTE_ALTURA_CM = 7.1;
export const PASSAPORTE_FOTO_W = Math.round(
  (PASSAPORTE_LARGURA_CM * 300) / 2.54
); // 602px
export const PASSAPORTE_FOTO_H = Math.round(
  (PASSAPORTE_ALTURA_CM * 300) / 2.54
); // 839px

export class PassaporteFormat extends BaseFormat {
  constructor(options = {}) {
    super(options);
    this.previewScale = options.previewScale ?? 0.5;
  }

  get tipo() {
    return "passaporte";
  }

  get canvasSize() {
    // Mesma conta do 3x4: canvas = foto × 2 × previewScale.
    // A 0,5: canvas 591×827 | export (scaleFinal=2) = 1182×1654
    return {
      width: PASSAPORTE_FOTO_W * 2 * this.previewScale,
      height: PASSAPORTE_FOTO_H * 2 * this.previewScale,
    };
  }

  get scaleFinal() {
    return 1 / this.previewScale;
  }

  // Foto de documento: sem moldura. O editor nem oferece o menu Molduras.
  get supportsMolduras() {
    return false;
  }

  // Como o 3x4 (PHOT-159), passaporte é sempre retrato: o editor não oferece
  // o botão Retrato/Paisagem.
  get supportsOrientation() {
    return false;
  }

  filterMolduras(listaMolduras, orientationId) {
    return listaMolduras.filter(
      (m) => m.dados.tipo === this.tipo && m.dados.orientacao === orientationId
    );
  }
}
